import React from 'react'
import { Box } from '@usap/uicomponents'
import { noBannerYMMPages } from '@usap/carparts/src/shared/components/HeaderWmo'
import { LinkStyle } from './style/Breadcrumbs.css'
import {
  LastLinkTextWithStyle, BreadcrumbsTextWithStyle, BreadcrumbsContainer, Divider, BreadCrumbWrapper,
} from './style/BreadcrumbsWMO.css'
import useBreadcrumbClickHandlers from './hooks/useBreadcrumbClickHandlers'

const getBreadCrumbName = str => {
  if (str == 'Payment Options') { return 'Payment Information' }
  if (str == 'Add New Payment Option') { return 'Add Payment Method' }
  if (str == 'Page not found') { return 'Page Not Found' }
  return str
}

const CheckForLastLink = props => {
  const {
    Link, useLastLinkFlag, item, maxLength,
  } = props

  return useLastLinkFlag
    ? (
      <Link
        to={item.link || item.url || item.value}
        style={LinkStyle}
      >
        <LastLinkTextWithStyle
          noPointer={maxLength}
          as={maxLength ? 'strong' : 'normal'}
        >
          {getBreadCrumbName(item.name || item.text)}
        </LastLinkTextWithStyle>
      </Link>
    )
    : (
      <LastLinkTextWithStyle
        noPointer={maxLength}
        as={maxLength ? 'strong' : 'normal'}
      >
        {getBreadCrumbName(item.name || item.text)}
      </LastLinkTextWithStyle>
    )
}

export default function BreadcrumbWMO({
  id = 'breadcrumb',
  links = [],
  Link = () => '',
  useLastLinkFlag = false,
  isScroll = true,
}) {
  const clickHandlers = useBreadcrumbClickHandlers(links)

  // when mfe header vehicle selector is showing, it covers the breadcrumb on desktop
  const { pageType } = __BROWSER__ && window.__COMBINED_DATA__
  const isMfeHeaderVehicleSelectorShowing = !noBannerYMMPages.includes(pageType)
  const isNotFound = pageType === 'page_notfound'? true : false;

  if (typeof links[2] !== 'undefined' && links[2].text === 'Order Details') {
    return null
  }

  const { length } = links

  return (
    <BreadCrumbWrapper id={`${id}-wrapper`} isMfeHeaderVehicleSelectorShowing={isMfeHeaderVehicleSelectorShowing} isNotFound={isNotFound}>
      <BreadcrumbsContainer
        id="breadCrumbList"
        as="ul"
        className={isScroll ? 'breadCrumbListScrollable' : ''}
        isNotFound={isNotFound}
      >
        {links.map((item, index) => {
          const maxLength = length === index + 1

          return (
            <Box
              id={(item.name || item.text).replace(/ /g, '')}
              key={item.name || item.text}
              as="li"
              direction="row"
              align="center"
              justify="center"
            >
              {maxLength
                ? (
                  <CheckForLastLink
                    Link={Link}
                    useLastLinkFlag={useLastLinkFlag}
                    item={item}
                    maxLength={maxLength}
                  />
                )
                : (
                  <Link
                    to={item.link || item.url || item.value}
                    aria-label={item.name || item.text}
                    style={LinkStyle}
                    onClick={clickHandlers[index]}
                  >
                    <BreadcrumbsTextWithStyle
                      textAlign="center"
                      weight={maxLength ? 'bold' : 'normal'}
                      noPointer={maxLength}
                      itemProp="name"
                      content={item.name || item.text}
                    >
                      {getBreadCrumbName(item.name || item.text)}
                    </BreadcrumbsTextWithStyle>
                  </Link>
                )}

              {!maxLength && (
                <Divider>
                  |
                </Divider>
              )}
            </Box>
          )
        })}
      </BreadcrumbsContainer>
    </BreadCrumbWrapper>
  )
}
